import React from "react";
import { useInView } from 'react-intersection-observer';

const Video = ({ file, extraclass, id }) => {
  const { ref: divdRef, inView: divIsVisible } = useInView({
    threshold: .4,
    triggerOnce: true
  });
  return (
    <div ref={divdRef}>
      {
        divIsVisible ?
          <video
            id={id}
            playsInline
            loop
            muted
            controls="" autoPlay preload=""
            className={`hidden md:block ${extraclass}`}
          >
            <source src={`/videos/mp4/${file}.mp4`} type="video/mp4" />
            <source src={`/videos/webm/${file}.webm`} type="video/webm" />
          </video>
          : ""
      }
    </div>
  )
}

export default Video
